<template>
  <div class="navbar">
    <!-- <notice-com /> -->
    <!-- <insureAdvice></insureAdvice> -->
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container"
      @toggleClick="toggleSideBar" />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <search id="header-search" class="right-menu-item" />
        <!--        <error-log class="errLog-container right-menu-item hover-effect" />-->

        <screenfull id="screenfull" class="right-menu-item hover-effect" />
      </template>

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          {{ JavaInfo.realName }}
          <i class="el-icon-arrow-down el-icon--right"></i>
          <!--<img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar">-->
          <!--<i class="el-icon-caret-bottom" />-->
        </div>
        <el-dropdown-menu slot="dropdown">
          <!--          <router-link to="/profile/index">-->
          <!--            <el-dropdown-item>Profile</el-dropdown-item>-->
          <!--          </router-link>-->
          <router-link to="/">
            <el-dropdown-item>工作台</el-dropdown-item>
          </router-link>
          <router-link :to="{ path: '/maintain/user' }" v-if="!isPhone">
            <el-dropdown-item v-if="JavaInfo.shopList.length == 0">个人中心</el-dropdown-item>
          </router-link>
          <!--<el-dropdown-item @click.native="onUnbundling">解绑账号</el-dropdown-item>-->
          <!--          <a target="_blank" href="https://github.com/PanJiaChen/vue-element-admin/">-->
          <!--            <el-dropdown-item>Github</el-dropdown-item>-->
          <!--          </a>-->
          <!--          <a target="_blank" href="https://panjiachen.github.io/vue-element-admin-site/#/">-->
          <!--            <el-dropdown-item>Docs</el-dropdown-item>-->
          <!--          </a>-->
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="right-menu" style="margin-right: 20px; color: #5a5e66; font-size: 15px">
      <!-- 切换时先在当前页面刷新token，然后直接刷新页面，用location -->
      {{ JavaInfo.shopList.length == 0 ? JavaInfo.shopName : '' }}
      <el-select v-model="JavaInfo.shopId" placeholder="请选择" value-key="value" v-if="JavaInfo.shopList.length != 0"
        @change="SwitchCompany">
        <el-option v-for="item in JavaInfo.shopList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="right-menu" style="margin-right: 20px; margin-top: -11px; color: #5a5e66; font-size: 15px">
      <span>
        <el-popover width="300" trigger="hover" @show="UnReadMessageOverview()">
          <div class="titleMessage">
            <div class="left">未读通知</div>
            <div class="right" @click="readAll()">全部已读</div>
          </div>
          <div class="empty">
            <div class="box" v-for="(item, index) in UnReadMessageList" :key="index">
              <div class="title">
                <i class="el-icon-info" style="font-size: 15px; color: #409eff; margin-right: 5px"></i>
                <div class="info">{{ item.title }}</div>
              </div>
              <div @click="handleClick(item, $event)" class="content" v-html="item.content"></div>
            </div>
            <el-empty :image-size="100" v-if="UnReadMessageList.length === 0"></el-empty>
          </div>
          <div class="lookAll" @click="hiddendanger">查看全部消息</div>
          <el-badge slot="reference" :value="unReadCount" :max="99" :hidden="unReadCount === 0 ? true : false"
            style="margin-top: 10px; margin-right: 20px; width: 20px; height: 35px; cursor: pointer">
            <i class="el-icon-bell" style="margin-right: 20px; color: #5a5e66; font-size: 20px"
              @click="hiddendanger"></i>
          </el-badge>
        </el-popover>
      </span>
    </div>
    <div class="right-menu" style="margin-right: 20px; margin-top: 4px; color: #5a5e66; font-size: 15px">
      <img style="width: 20px;height: 20px;cursor: pointer;" src="@/assets/imgs/helpCenter.png" alt=""
        @click="goHelpCenter">
    </div>
  </div>
</template>

<script>
import { getUnReadMessageCount, getUnReadMessageOverview, readAll, getUnDeliveredMessage } from '@/api/stationMessage'
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import Search from '@/components/HeaderSearch'
import NoticeCom from '@/views/components/noticeCom.vue'
// import insureAdvice from "@/views/components/insureAdvice.vue";
import { unbindApi } from '@/api/wxApi'
import Cookies from 'js-cookie'
import { color } from 'echarts/lib/export'
import { getToken, removeToken, setToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'
import { refreshToken } from '@/api/user'
import SettingMer from '@/utils/settingMer'
// import store from '@/vuex/store.js'
import lodash from 'lodash'
export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    Search,
    NoticeCom
  },

  data () {
    return {
      isPhone: this.$wechat.isPhone(),
      JavaInfo: JSON.parse(Cookies.get('JavaInfo')),
      unReadCount: null,
      UnReadMessageList: [],
      route: '/'
      // shopList:[
      // {"value":6,"label":"悦芽照护（沈阳店）"},
      // {"value":1,"label":"悦芽照护（广州店）"},
      // {"value":4,"label":"悦芽照护（南京店）"},
      // {"value":5,"label":"悦芽照护（杭州店）"},
      // ],
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device', 'permission_routes'])
  },

  created () {
    // websocket
    this.connectWebsocket()
    this.getUnDeliveredMessage()
  },
  mounted () {

    // 在组件的mounted钩子中添加全局点击事件监听器
    document.addEventListener('click', this.handleGlobalClick);
  },
  // 在组件的beforeDestroy钩子中移除监听器
  beforeDestroy () {
    document.removeEventListener('click', this.handleGlobalClick);
  },
  methods: {
    goHelpCenter () {
      let url = window.document.location.origin
      const urls = url + '/helpCenter'
      window.open(urls)
    },
    handleGlobalClick (event) {
      // 检查点击的元素是否是我们想要的元素
      let Eclass = '.' + event.target.className
      if (event.target.tagName == 'A' && event.target.matches(Eclass)) {
        let url = Eclass.replace(/-/g, '/').replace('.', '')
        let isUrl = this.routeExists(this.permission_routes, url)
        if (!isUrl) {
          this.$message.warning('您没有该页面权限，请联系管理员开通')
          return
        }
        this.$router.push({ path: url });
      }
    },
    routeExists (routes, URL) {
      for (let item of routes) {
        if (item.url === URL) {
          return true;
        }
        if (item.child && item.child.length > 0) {
          const existsInChildren = this.routeExists(item.child, URL);
          if (existsInChildren) {
            return true;
          }
        }
      }
      return false;
    },
    handleClick (item, event) {
      console.log(item, event, 'item, event')
      let Eclass = '.' + event.target.className
      if (event.target.tagName === 'A') {
        let url = Eclass.replace(/-/g, '/').replace('.', '')
        let isUrl = this.routeExists(this.permission_routes, url)
        if (!isUrl) {
          this.$message.warning('您没有该页面权限，请联系管理员开通')
          return
        }
        this.$router.push({ path: url });
        event.preventDefault(); // 阻止默认的链接行为
      }
    },
    // 全部已读
    readAll () {
      this.UnReadMessageList = []
      readAll().then(res => {
        // if(res==[]){
        this.$message({
          message: '全部已读！',
          type: 'success'
        })
        this.UnReadMessageCount()
        // }
      })
    },
    // 获取未投递消息列表
    getUnDeliveredMessage () {
      getUnDeliveredMessage().then(res => {
        res.forEach(item => {
          this.timer = setTimeout(() => {
            this.$notify({
              title: item.title,
              dangerouslyUseHTMLString: true,
              message: item.content,
              type: 'warning',
              duration: 300000,
              offset: 20
            })
          }, 0)
        })
      })
    },
    UnReadMessageOverview () {
      getUnReadMessageOverview().then(res => {
        // console.log(res,'65555');
        this.UnReadMessageList = res
        this.UnReadMessageCount()
      })
    },
    SwitchCompany (val) {
      console.log(val)
      refreshToken(val).then(res => {
        resetRouter()
        localStorage.clear()
        var info = JSON.parse(Cookies.get('JavaInfo'))
        info.shopId = val
        info.shopList.filter(item => {
          if (item.id == val) {
            info.shopName = item.name
          }
        })
        Cookies.set('JavaInfo', info)
        window.location.href = window.location.href
      })
    },
    connectWebsocket () {
      const url = SettingMer.httpUrl.replace('http', 'ws')
      let that = this
      const token = this.$store.getters.token
      this.websocket = new WebSocket(`${url}/websocket?token=${token}`)
      this.websocket.onerror = function (event) { }
      // 连接成功建立的回调方法
      this.websocket.onopen = function (event) {
        that.UnReadMessageCount()
        // 发送心跳消息
        that.heartBeat = setInterval(function () {
          var beatMessage = {
            type: 2,
            data: 'ping'
          }
          that.websocket.send(JSON.stringify(beatMessage))
        }, 30 * 1000)
      }
      // 接收到消息的回调方法
      this.websocket.onmessage = function (event) {
        const data = JSON.parse(event.data)
        console.log(data, 'datas')
        // console.log(data,'event');
        // if (data.type === 2) return
        // if (that.wsList == data.data) return
        if (data.type === 1) {
          let notifyData = lodash.cloneDeep(data.data)
          // notifyData.content = notifyData.content.replace('custom-notification-link', data.data.route)
          // that.wsList = []
          // that.wsList .push(data.data)
          that.$notify({
            title: notifyData.title,
            dangerouslyUseHTMLString: true,
            message: notifyData.content,
            type: 'warning',
            duration: 300000,
          })
          that.UnReadMessageCount()
        } else if (data.type === 3) {
          that.UnReadMessageCount()
        }

        // let arr = []
        // arr.push({
        //   content: data.data.content,
        //   messageId: data.data.messageId
        // })
        // that.wsList = new Set(arr);
      }
      //连接关闭的回调方法
      this.websocket.onclose = function (e) {
        console.log(e, '断开了')
      }
    },
    //获取小铃铛未读消息数量
    UnReadMessageCount () {
      getUnReadMessageCount().then(res => {
        // console.log(res,'######');
        this.unReadCount = res.unReadCount
      })
    },
    // 点击铃铛去消息中心
    hiddendanger () {
      // console.log(11111);
      this.$router.push({ path: '/technician/message' })
    },

    onUnbundling () {
      this.$modalSure('解绑微信吗').then(() => {
        unbindApi().then(() => {
          this.$message.success('解绑成功')
        })
      })
    },
    toggleSideBar () {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout () {
      await this.$store.dispatch('user/logout')
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      this.$router.push(`/login`)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-badge {
  /deep/.el-badge__content.is-fixed {
    margin: 7px -2px;
  }
}

.titleMessage {
  display: flex;
  justify-content: space-between;

  .left {
    color: #606266;
    font-weight: 700;
  }

  .right {
    color: #409eff;
    cursor: pointer;
  }
}

.empty {
  width: 100%;
  height: 250px;
  overflow: auto;
  margin-top: 10px;
  border-top: #e4e7ed 1px solid;
  border-bottom: #e4e7ed 1px solid;

  // background-color: #C0C4CC;
  .box {
    cursor: pointer;

    .title {
      margin-top: 10px;
      display: flex;
      align-items: center;

      .info {
        color: black;
        font-weight: 700;
      }
    }

    .content {
      color: #909399;
      font-size: 12px;
    }
  }
}

.lookAll {
  margin-top: 10px;
  width: 100%;
  text-align: center;
  color: #409eff;
  cursor: pointer;
}

.el-badge__content.is-fixed {
  top: 7px;
}

.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        position: relative;
        font-size: 14px;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
